import React from 'react';

function Dots({ children, dotsHook, carouselState }) {
  const { selectedIndex, scrollSnaps, onDotButtonClick } = dotsHook;
  const { hasDots, hasItemsToScroll } = carouselState;

  if (!hasDots || !hasItemsToScroll) {
    return null;
  }

  return (
    <div className="mn_carouselDots">
      {scrollSnaps.map((item, index) => (
        <button
          type="button"
          key={item}
          onClick={() => onDotButtonClick(index)}
          className={`mn_carouselDot ${index === selectedIndex ? ' mn_active' : ''}`}
          aria-label={index === selectedIndex ? `Current slide ${index + 1}` : `Go to slide ${index + 1}`}
        >
          {children}
        </button>
      ))}
    </div>
  );
}

export default Dots;
